import { useTranslation } from "react-i18next";
import { ShowLoadingScreen } from "components/common/Loading";
import { GetSingleProductAPI } from "network/productAPI";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { formatDecimalWithComma } from "utils/formatDecimalWithComma";
import CountryList from "country-list-with-dial-code-and-flag";
import CountryFlagSvg from "country-list-with-dial-code-and-flag/dist/flag-svg";
import parse from "html-react-parser";

export default function SingleProductDetail({ sectionData }) {
  const { t } = useTranslation("products");
  const [singleData, setSingleData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { id } = useParams();
  const navigate = useNavigate();
  const countryName =
    singleData?.attributes?.country &&
    CountryList.findOneByCountryCode(singleData?.attributes?.country);
  async function getSingleData() {
    try {
      const response = await GetSingleProductAPI(
        sectionData?.uuid,
        id,
        "default"
      );

      setSingleData(response?.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getSingleData();
  }, [id]);
  const formatWithUnitOrDash = (value, unit = "") => {
    const formatted = formatDecimalWithComma(value);
    return formatted ? `${formatted}${unit}` : "-";
  };

  if (loading) {
    return <ShowLoadingScreen />;
  }
  return (
    <div className="content singlewinedetail">
      <div className=" mt-5 singleWinepage">
        <Container>
          <div className="d-flex flex-wrap gap-5 mb-4">
            <Button
              onClick={() => navigate(-1)}
              className="btn btn-primary d-flex flex-wrap gap-5 align-items-center"
            >
              <i
                className="tim-icons icon-minimal-left
                  
                  font-weight-bold mr-2  font-size-xl"
              ></i>
              <span>{t("detail.back")}</span>
            </Button>
          </div>
          {singleData?.attributes ? (
            <>
              <div className="mb-4">
                <h1 className="mb-3">{singleData?.name}</h1>
              </div>

              <div className="row mb-4">
                <div className="col-md-10">
                  <div className="row">
                    <div className="col-6 col-md-3">
                      <p className="mb-3">
                        <strong className="text-capitalize">{t("detail.labels.ean")}</strong>
                        <br />
                        {singleData?.attributes?.ean || t("detail.na")}
                      </p>
                    </div>
                    <div className="col-6 col-md-3">
                      <p className="mb-3">
                        <strong className="text-capitalize">{t("detail.labels.vintage")}</strong>
                        <br />
                        {formatDecimalWithComma(
                          singleData?.attributes?.vintage
                        ) || t("detail.na")}
                      </p>
                    </div>
                    {/* <div className="col-6 col-md-3">
                    <p className="mb-3">
                      <strong className="text-capitalize">Is Active:</strong>
                      <br />

                      {singleData?.attributes?.is_active === true
                        ? t("detail.yes")
                        : singleData?.attributes?.is_active === false
                        ? t("detail.no")
                        : "-"}
                    </p>
                  </div> */}
                    {/* <div className="col-6 col-md-3">
                    <p className="mb-3">
                      <strong className="text-capitalize">Is Approved:</strong>
                      <br />
                      {singleData?.attributes?.is_approved === true
                        ? t("detail.yes")
                        : singleData?.attributes?.is_approved === false
                        ? t("detail.no")
                        : "-"}
                    </p>
                  </div> */}
                    <div className="col-6 col-md-3">
                      <p className="mb-3">
                        <strong className="text-capitalize">{t("detail.labels.dataset")}</strong>
                        <br />
                        {singleData?.has_wine_data ? t("detail.yes") : t("detail.no")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-2 text-md-end mt-3 mt-md-0">
                  <p className="mb-1">
                    <strong>{t("detail.labels.country")}</strong>
                  </p>
                  {countryName?.code && CountryFlagSvg[countryName.code] ? (
                    <div className="d-flex flex-wrap gap-5 align-items-center">
                      <span className="flag-icon">
                        {parse(CountryFlagSvg[countryName.code])}
                      </span>
                      <p className="mb-0 pr-2">{countryName.name}</p>
                    </div>
                  ) : (
                    <p className="mb-0">{t("detail.na")}</p>
                  )}
                </div>
              </div>

              <div className="row my-5">
                <div className="col-12 col-md-3">
                  <p className="mb-3 text-capitalize">
                    <strong>{t("detail.labels.categories")}</strong>
                  </p>
                  {singleData?.categories?.length > 0 ? (
                    <ul>
                      {singleData?.categories.map((category) => (
                        <li key={category.id}>{category.name}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>{t("detail.noCategory")}</p>
                  )}
                </div>

                <div className="col-12 col-md-3">
                  <p className="mb-3 text-capitalize">
                    <strong>{t("detail.labels.subCategories")}</strong>
                  </p>
                  {singleData?.sub_categories?.length > 0 ? (
                    <ul>
                      {singleData.sub_categories.map((subCategory) => (
                        <li key={subCategory.id}>{subCategory.name}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>{t("detail.noSubCategory")}</p>
                  )}
                </div>
              </div>

              <div className="row my-5">
                <div className=" col-12 col-md-6 col-lg-3">
                  <p>
                    <strong>{t("detail.labels.frontBottleImage")}</strong>
                  </p>
                  {singleData?.attributes?.front_bottle_image ? (
                    <div className="singleImage_container">
                      <img
                        style={{ objectFit: "cover" }}
                        className="productImage mb-3 fit-cover "
                        src={`${process.env.REACT_APP_BASE_URL}${singleData?.attributes?.front_bottle_image}`}
                        alt={t("detail.altFrontBottle")}
                      />
                    </div>
                  ) : (
                    <p>{t("detail.noImage")}</p>
                  )}
                </div>

                <div className=" col-12 col-md-6 col-lg-3">
                  <p>
                    <strong>{t("detail.labels.backBottleImage")}</strong>
                  </p>
                  {singleData?.attributes?.back_bottle_image ? (
                    <div className="singleImage_container">
                      <img
                        style={{ objectFit: "cover" }}
                        className="productImage mb-3 fit-cover "
                        src={`${process.env.REACT_APP_BASE_URL}${singleData?.attributes?.back_bottle_image}`}
                        alt={t("detail.altBackBottle")}
                      />
                    </div>
                  ) : (
                    <p>{t("detail.noImage")}</p>
                  )}
                </div>

                <div className=" col-12 col-md-6 col-lg-3">
                  <p>
                    <strong>{t("detail.labels.frontLabelImage")}</strong>
                  </p>
                  {singleData?.attributes?.front_label_image ? (
                    <div className="singleImage_container">
                      <img
                        style={{ objectFit: "cover" }}
                        className="productImage mb-3 fit-cover "
                        src={`${process.env.REACT_APP_BASE_URL}${singleData?.attributes?.front_label_image}`}
                        alt={t("detail.altFrontLabel")}
                      />
                    </div>
                  ) : (
                    <p>{t("detail.noImage")}</p>
                  )}
                </div>
                <div className=" col-12 col-md-6 col-lg-3">
                  <p>
                    <strong>{t("detail.labels.backLabelImage")}</strong>
                  </p>
                  {singleData?.attributes?.back_label_image ? (
                    <div className="singleImage_container">
                      <img
                        style={{ objectFit: "cover" }}
                        className="productImage mb-3 fit-cover "
                        src={`${process.env.REACT_APP_BASE_URL}${singleData?.attributes?.back_label_image}`}
                        alt={t("detail.altBackLabel")}
                      />
                    </div>
                  ) : (
                    <p>{t("detail.noImage")}</p>
                  )}
                </div>
              </div>

              <div>
                <p className="mb-3 ">
                  <strong className="text-capitalize global-width">{t("detail.labels.description")}</strong>
                  <br /> {singleData?.attributes?.description || "-"}
                </p>
                <p className="mb-3 ">
                  <strong className="text-capitalize global-width">{t("detail.labels.fermentation")}</strong>
                  <br /> {singleData?.attributes?.fermentation || "-"}
                </p>
                <p className="mb-3 ">
                  <strong className="text-capitalize global-width">{t("detail.labels.vinification")}</strong>
                  <br /> {singleData?.attributes?.vinification || "-"}
                </p>
                <p className="mb-3 ">
                  <strong className="text-capitalize global-width">{t("detail.labels.terroir")}</strong>
                  <br /> {singleData?.attributes?.terroir || "-"}
                </p>
                <p className="mb-3 ">
                  <strong className="text-capitalize global-width">{t("detail.labels.region")}</strong>
                  <br /> {singleData?.attributes?.region || "-"}
                </p>

                <div className="row gap-row-16 mt-5">
                  <div className="col-12 col-md-6">
                    <ul
                      className="mb-3 list-unstyled p-4 border-1 border rounded "
                      style={{ height: "100%" }}
                    >
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.taste")}</strong>
                        <span>{singleData?.attributes?.taste || "-"}</span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.colour")}</strong>
                        <span>{singleData?.attributes?.colour || "-"}</span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.energy")}</strong>

                        <span>{singleData?.attributes?.energy || "-"}</span>
                      </li>

                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.winery")}</strong>
                        <span>{singleData?.attributes?.winery || "-"}</span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.pairing")}</strong>
                        <span>{singleData?.attributes?.pairing || "-"}</span>
                      </li>

                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.ingredients")}</strong>
                        <span>
                          {singleData?.attributes?.ingredients || "-"}
                        </span>
                      </li>
                      <li className="mb-3 d-flex  flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.denomination")}</strong>
                        <span>
                          {singleData?.attributes?.denomination || "-"}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-12 col-md-6">
                    <ul
                      className="mb-3 list-unstyled p-4 border-1 border rounded "
                      style={{ height: "100%" }}
                    >
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.bio")}</strong>
                        <br />
                        <span>
                          {singleData?.attributes?.bio === true
                            ? t("detail.yes")
                            : singleData?.attributes?.bio === false
                            ? t("detail.no")
                            : "-"}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.natural")}</strong>
                        <br />
                        <span>
                          {singleData?.attributes?.natural === true
                            ? t("detail.yes")
                            : singleData?.attributes?.natural === false
                            ? t("detail.no")
                            : "-"}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.biodynamic")}</strong>
                        <br />
                        <span>
                          {singleData?.attributes?.biodynamic === true
                            ? t("detail.yes")
                            : singleData?.attributes?.biodynamic === false
                            ? t("detail.no")
                            : "-"}
                        </span>
                      </li>

                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.haveSulphite")}</strong>
                        <br />

                        <span>
                          {singleData?.attributes?.have_sulphite === true
                            ? t("detail.yes")
                            : singleData?.attributes?.have_sulphite === false
                            ? t("detail.no")
                            : "-"}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.conventional")}</strong>
                        <br />
                        <span>
                          {singleData?.attributes?.conventional === true
                            ? t("detail.yes")
                            : singleData?.attributes?.conventional === false
                            ? t("detail.no")
                            : "-"}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-12 col-md-6 ">
                    <ul
                      className="mb-3 list-unstyled p-4 border-1 border rounded"
                      style={{ height: "100%" }}
                    >
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.fat")}</strong>
                        <span>
                          {formatWithUnitOrDash(
                            singleData?.attributes?.fat,
                            "g"
                          )}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.salt")}</strong>
                        <span>
                          {formatWithUnitOrDash(
                            singleData?.attributes?.salt,
                            "g"
                          )}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.sugar")}</strong>
                        <span>
                          {formatWithUnitOrDash(
                            singleData?.attributes?.sugar,
                            "g"
                          )}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.protein")}</strong>
                        <span>
                          {formatWithUnitOrDash(
                            singleData?.attributes?.protein,
                            "g"
                          )}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.carbohydrate")}</strong>
                        <span>
                          {formatWithUnitOrDash(
                            singleData?.attributes?.carbohydrate,
                            "g"
                          )}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.saturatedFat")}</strong>
                        <span>
                          {formatWithUnitOrDash(
                            singleData?.attributes?.saturated_fat,
                            "g"
                          )}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.format")}</strong>
                        <span>
                          {formatWithUnitOrDash(
                            singleData?.attributes?.format,
                            "L"
                          )}
                        </span>
                      </li>
                      <li className="mb-3 d-flex flex-wrap gap-5 justify-content-between">
                        <strong className="text-capitalize global-width">{t("detail.labels.gradation")}</strong>
                        <span>
                          {formatWithUnitOrDash(
                            singleData?.attributes?.gradation,
                            "%"
                          )}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <h2 className="text-center mt-5">{t("detail.noRecords")}</h2>
          )}
        </Container>
      </div>
    </div>
  );
}
